/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IBrandApi {
    getBrands(cancelToken?: CancelToken): AxiosPromise<BrandModel[]>;
    createBrand(cancelToken?: CancelToken): AxiosPromise<string>;
    makeDefault(brandId: string, cancelToken?: CancelToken): AxiosPromise<void>;
    share(brandId: string, cancelToken?: CancelToken): AxiosPromise<void>;
    getBrandSettings(getBrandRequest: GetBrandRequest, cancelToken?: CancelToken): AxiosPromise<BrandSettingsResponseModel>;
    updateBrandSettings(updateBrandSettingsRequest: UpdateBrandSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    complete(completeBrandRequest: CompleteBrandRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    archive(archiveBrandRequest: ArchiveBrandRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    restore(restoreBrandRequest: RestoreBrandRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    generateSmsOptInForm(generateSmsOptInFormRequest: GenerateSmsOptInFormRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInFormResponse>;
    getSmsOptInForm(getSmsOptInFormRequest: GetSmsOptInFormRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInFormResponse>;
    getSmsUrlShorteningDomainConfiguration(cancelToken?: CancelToken): AxiosPromise<GetSmsUrlShorteningDomainConfigurationResponse>;
    getSmsOptInLink(getSmsOptInFormRequest: GetSmsOptInLinkRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInLinkQueryResponse>;
    getAvailablePhoneNumbers(request: GetAvailablePhoneNumberRequest, cancelToken?: CancelToken): AxiosPromise<AvailablePhoneNumberResponse[]>;
    setOptInRequestSenderNumber(request: SetOptInRequestSenderNumberRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    getOptInRequestSenderNumber(request: GetOptInRequestSenderNumberRequest, cancelToken?: CancelToken): AxiosPromise<OptInRequestSenderNumberResponse>;
    getTcrDataResponse(request: GetTcrDataRequest, cancelToken?: CancelToken): AxiosPromise<TcrDataResponse>;
    getTcrBrands(cancelToken?: CancelToken): AxiosPromise<TcrBrandModel[]>;
    updateTcrBrand(request: UpdateTcrBrandRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    createTcrCampaign(request: CreateTcrCampaignRequest, cancelToken?: CancelToken): AxiosPromise<CreateTcrCampaignResponse>;
    archiveUrlShorteningSubdomain(archiveUrlShorteningDomainRequest: ArchiveUrlShorteningDomainRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    getBrandPhoneNumbersSettings(request: GetBrandPhoneNumberRequest, cancelToken?: CancelToken): AxiosPromise<GetBrandPhoneNumberSettingsResponse>;
    updatePhoneNumberSettings(request: UpdateBrandPhoneNumberSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    getSmsRegistration(request: GetSmsRegistrationRequest, cancelToken?: CancelToken): AxiosPromise<SmsRegistration>;
    sendSmsRegistration(request: SendSmsRegistrationRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    findBusinessByEin(request: FindByEinRequest, cancelToken?: CancelToken): AxiosPromise<ResultOfBusinessResult>;
    getAvailableStockExchanges(cancelToken?: CancelToken): AxiosPromise<GetBrandStockExchangesResponse>;
    getAvailableCountriesWithStates(cancelToken?: CancelToken): AxiosPromise<CountriesWithStatesResponse>;
    setTcrCampaign(request: UpdateTcrMarketingCampaignRequest, cancelToken?: CancelToken): AxiosPromise<void>;
    getAvailableEmailSenderDomains(cancelToken?: CancelToken): AxiosPromise<AvailableDomainsResponse>;
    getEmails(request: GetEmailsRequest, cancelToken?: CancelToken): AxiosPromise<GetEmailsResponse>;
    downloadEmails(cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_BrandApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_BrandApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class BrandApi implements IBrandApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_BrandApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_BrandApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getBrands(cancelToken?: CancelToken): AxiosPromise<BrandModel[]> {
        let url_ = "/marketing/api/brands/Brand/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<BrandModel[]>(options_);
    }

    createBrand(cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = "/marketing/api/brands/Brand/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<string>(options_);
    }

    makeDefault(brandId: string, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/make-default?";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined and cannot be null.");
        else
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    share(brandId: string, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/share?";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined and cannot be null.");
        else
            url_ += "brandId=" + encodeURIComponent("" + brandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    getBrandSettings(getBrandRequest: GetBrandRequest, cancelToken?: CancelToken): AxiosPromise<BrandSettingsResponseModel> {
        let url_ = "/marketing/api/brands/Brand/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = getBrandRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<BrandSettingsResponseModel>(options_);
    }

    updateBrandSettings(updateBrandSettingsRequest: UpdateBrandSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = updateBrandSettingsRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    complete(completeBrandRequest: CompleteBrandRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = completeBrandRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    archive(archiveBrandRequest: ArchiveBrandRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = archiveBrandRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    restore(restoreBrandRequest: RestoreBrandRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = restoreBrandRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    generateSmsOptInForm(generateSmsOptInFormRequest: GenerateSmsOptInFormRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInFormResponse> {
        let url_ = "/marketing/api/brands/Brand/generate-sms-opt-in-form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = generateSmsOptInFormRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<SmsOptInFormResponse>(options_);
    }

    getSmsOptInForm(getSmsOptInFormRequest: GetSmsOptInFormRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInFormResponse> {
        let url_ = "/marketing/api/brands/Brand/get-sms-opt-in-form";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = getSmsOptInFormRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<SmsOptInFormResponse>(options_);
    }

    getSmsUrlShorteningDomainConfiguration(cancelToken?: CancelToken): AxiosPromise<GetSmsUrlShorteningDomainConfigurationResponse> {
        let url_ = "/marketing/api/brands/Brand/get-sms-url-shortening-domain-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetSmsUrlShorteningDomainConfigurationResponse>(options_);
    }

    getSmsOptInLink(getSmsOptInFormRequest: GetSmsOptInLinkRequest, cancelToken?: CancelToken): AxiosPromise<SmsOptInLinkQueryResponse> {
        let url_ = "/marketing/api/brands/Brand/get-sms-opt-in-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = getSmsOptInFormRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<SmsOptInLinkQueryResponse>(options_);
    }

    getAvailablePhoneNumbers(request: GetAvailablePhoneNumberRequest, cancelToken?: CancelToken): AxiosPromise<AvailablePhoneNumberResponse[]> {
        let url_ = "/marketing/api/brands/Brand/get-available-phone-numbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<AvailablePhoneNumberResponse[]>(options_);
    }

    setOptInRequestSenderNumber(request: SetOptInRequestSenderNumberRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/set-opt-in-request-sender-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    getOptInRequestSenderNumber(request: GetOptInRequestSenderNumberRequest, cancelToken?: CancelToken): AxiosPromise<OptInRequestSenderNumberResponse> {
        let url_ = "/marketing/api/brands/Brand/get-opt-in-request-sender-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<OptInRequestSenderNumberResponse>(options_);
    }

    getTcrDataResponse(request: GetTcrDataRequest, cancelToken?: CancelToken): AxiosPromise<TcrDataResponse> {
        let url_ = "/marketing/api/brands/Brand/get-tcr-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<TcrDataResponse>(options_);
    }

    getTcrBrands(cancelToken?: CancelToken): AxiosPromise<TcrBrandModel[]> {
        let url_ = "/marketing/api/brands/Brand/get-tcr-brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<TcrBrandModel[]>(options_);
    }

    updateTcrBrand(request: UpdateTcrBrandRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/update-tcr-brand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    createTcrCampaign(request: CreateTcrCampaignRequest, cancelToken?: CancelToken): AxiosPromise<CreateTcrCampaignResponse> {
        let url_ = "/marketing/api/brands/Brand/create-tcr-campaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<CreateTcrCampaignResponse>(options_);
    }

    archiveUrlShorteningSubdomain(archiveUrlShorteningDomainRequest: ArchiveUrlShorteningDomainRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/archive-url-shortening-subdomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = archiveUrlShorteningDomainRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    getBrandPhoneNumbersSettings(request: GetBrandPhoneNumberRequest, cancelToken?: CancelToken): AxiosPromise<GetBrandPhoneNumberSettingsResponse> {
        let url_ = "/marketing/api/brands/Brand/phone-number-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetBrandPhoneNumberSettingsResponse>(options_);
    }

    updatePhoneNumberSettings(request: UpdateBrandPhoneNumberSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/phone-number-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    getSmsRegistration(request: GetSmsRegistrationRequest, cancelToken?: CancelToken): AxiosPromise<SmsRegistration> {
        let url_ = "/marketing/api/brands/Brand/get-sms-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<SmsRegistration>(options_);
    }

    sendSmsRegistration(request: SendSmsRegistrationRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/send-sms-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    findBusinessByEin(request: FindByEinRequest, cancelToken?: CancelToken): AxiosPromise<ResultOfBusinessResult> {
        let url_ = "/marketing/api/brands/Brand/find-business-by-ein";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<ResultOfBusinessResult>(options_);
    }

    getAvailableStockExchanges(cancelToken?: CancelToken): AxiosPromise<GetBrandStockExchangesResponse> {
        let url_ = "/marketing/api/brands/Brand/stock-exchanges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetBrandStockExchangesResponse>(options_);
    }

    getAvailableCountriesWithStates(cancelToken?: CancelToken): AxiosPromise<CountriesWithStatesResponse> {
        let url_ = "/marketing/api/brands/Brand/countries-with-states";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<CountriesWithStatesResponse>(options_);
    }

    setTcrCampaign(request: UpdateTcrMarketingCampaignRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Brand/tcr-campaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    getAvailableEmailSenderDomains(cancelToken?: CancelToken): AxiosPromise<AvailableDomainsResponse> {
        let url_ = "/marketing/api/brands/Brand/available-email-sender-domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<AvailableDomainsResponse>(options_);
    }

    getEmails(request: GetEmailsRequest, cancelToken?: CancelToken): AxiosPromise<GetEmailsResponse> {
        let url_ = "/marketing/api/brands/Brand/emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetEmailsResponse>(options_);
    }

    downloadEmails(cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/marketing/api/brands/Brand/emails/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<FileResponse>(options_);
    }
}

export interface BrandModel {
    id: string;
    name?: string | undefined;
    email?: string | undefined;
    logo?: string | undefined;
    state: OnboardingBrandState;
    isDefault: boolean;
    isArchived: boolean;
    isShared: boolean;
    partitionId?: string | undefined;
    entityScope: EntityScope;
    domainValidationStatus?: DomainValidationStatus | undefined;
    tcrMarketingCampaignId?: number | undefined;
    tcrBrandId?: number | undefined;
    smsRegistrationStatus?: SmsRegistrationStatus | undefined;
}

export enum OnboardingBrandState {
    NotStarted = 0,
    BrandInProgress = 1,
    EmailNotStarted = 2,
    EmailInProgress = 3,
    Completed = 4,
}

export enum EntityScope {
    Current = 0,
    Effective = 1,
    Parent = 2,
}

export enum DomainValidationStatus {
    Unknown = 0,
    Validated = 1,
    Pending = 2,
    Error = 3,
}

export enum SmsRegistrationStatus {
    NotSubmitted = 0,
    Pending = 1,
    Active = 2,
    Failed = 3,
}

export interface BrandSettingsResponseModel {
    companyProperties?: CompanyProperties | undefined;
    emailProperties?: EmailProperties | undefined;
    trades?: SelectedTrades | undefined;
    smsProperties?: SmsProperties | undefined;
    termsAndConditionsProperties?: TermsAndConditionsProperties | undefined;
    partitionId?: string | undefined;
    entityScope: EntityScope;
    isShared: boolean;
    smsRegistrationStatus?: SmsRegistrationStatus | undefined;
    brandColors?: BrandColor | undefined;
}

export interface CompanyProperties {
    companyName?: string | undefined;
    tagline?: string | undefined;
    street?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    companyEmail?: string | undefined;
    yearEstablished?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    facebookUrl?: string | undefined;
    instagramUrl?: string | undefined;
    twitterUrl?: string | undefined;
    youtubeUrl?: string | undefined;
    tikTokUrl?: string | undefined;
    linkedInUrl?: string | undefined;
    pinterestUrl?: string | undefined;
    nextdoorUrl?: string | undefined;
    whatsAppUrl?: string | undefined;
    yelpUrl?: string | undefined;
}

export interface EmailProperties {
    editableProperties?: EmailPropertiesEditable | undefined;
    senderTopDomain?: string | undefined;
    domainValidationStatus?: DomainValidationStatus | undefined;
}

export interface EmailPropertiesEditable {
    senderName?: string | undefined;
    senderDomain?: string | undefined;
    senderEmail?: string | undefined;
    replyToEmail?: string | undefined;
    legalCopy?: string | undefined;
    license?: string | undefined;
    copyrightText?: string | undefined;
    senderTopDomain?: string | undefined;
    autoSuppressEmails?: boolean | undefined;
    daysForAutoSuppressEmails?: number | undefined;
    validationLevel?: ValidationLevel | undefined;
}

export enum ValidationLevel {
    Low = 1,
    Medium = 2,
    High = 3,
}

export interface SelectedTrades {
    trades?: TradesType[] | undefined;
}

export enum TradesType {
    HVAC = 1,
    Electrical = 2,
    Plumbing = 3,
    GarageDoor = 4,
    PestControl = 5,
    LawnCare = 6,
}

export interface SmsProperties {
    activeSubdomain?: string | undefined;
    urlShorteningDomains: UrlShorteningDomain[];
    tcrBrandId?: number | undefined;
    tcrMarketingCampaignId?: number | undefined;
    optInFormId?: string | undefined;
    optInLink?: string | undefined;
}

export interface UrlShorteningDomain {
    id: string;
    subdomain: string;
    fulldomain: string;
    isActive: boolean;
}

export interface TermsAndConditionsProperties {
    termsAndConditionsVersion: TermsAndConditionsVersion;
}

export enum TermsAndConditionsVersion {
    None = 0,
    V1 = 1,
}

export interface BrandColor {
    primary?: string | undefined;
    secondary?: string | undefined;
    tertiary?: string | undefined;
    mainBackgroundColor?: string | undefined;
}

export interface GetBrandRequest {
    brandId: string;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: any;

    [key: string]: any;
}

export interface BrandServiceProblemDetails extends ProblemDetails {
    errorCode: string;

    [key: string]: any;
}

export interface UpdateBrandSettingsRequest {
    entityId: string;
    brandSettings: BrandSettingsUpdateModel;
}

export interface BrandSettingsUpdateModel {
    companyProperties?: CompanyProperties | undefined;
    emailProperties?: EmailPropertiesEditable | undefined;
    trades?: SelectedTrades | undefined;
    smsProperties?: SmsPropertiesUpdate | undefined;
    termsAndConditionsProperties?: TermsAndConditionsPropertiesUpdate | undefined;
    brandColors?: BrandColor | undefined;
}

export interface SmsPropertiesUpdate {
    activeSubdomain?: string | undefined;
}

export interface TermsAndConditionsPropertiesUpdate {
    termsAndConditionsVersion: TermsAndConditionsVersion;
}

export interface CompleteBrandRequest {
    entityId: string;
    type: SettingsType;
}

export enum SettingsType {
    Brand = 0,
    Email = 1,
}

export interface ArchiveBrandRequest {
    brandId: string;
}

export interface RestoreBrandRequest {
    brandId: string;
}

export interface SmsOptInFormResponse {
    token: string;
    iframeUrl: string;
}

export interface GenerateSmsOptInFormRequest {
    brandId: string;
}

export interface GetSmsOptInFormRequest {
    brandId: string;
}

export interface GetSmsUrlShorteningDomainConfigurationResponse {
    domain: string;
    overriddenSubdomain: string;
    dedicatedDomain: string;
    canEditSubdomain: boolean;
    defaultSubdomain: string;
}

export interface SmsOptInLinkQueryResponse {
    url: string;
}

export interface GetSmsOptInLinkRequest {
    brandId: string;
}

export interface AvailablePhoneNumberResponse {
    phoneNumber: string;
    state: string;
}

export interface GetAvailablePhoneNumberRequest {
    isLocal?: boolean | undefined;
    areaCode?: string | undefined;
    zipCode?: string | undefined;
    contains?: string | undefined;
}

export interface SetOptInRequestSenderNumberRequest {
    brandId: string;
    phoneNumber: string;
}

export interface OptInRequestSenderNumberResponse {
    phoneNumber: string;
}

export interface GetOptInRequestSenderNumberRequest {
    brandId: string;
}

export interface TcrDataResponse {
    brandData?: BrandDataResponse | undefined;
    defaultTcrCampaigns?: TcrCampaignResponse[] | undefined;
    marketingTcrCampaigns?: TcrCampaignResponse[] | undefined;
}

export interface BrandDataResponse {
    brandId: number;
    externalId: string;
    error?: string | undefined;
    state: State;
    data?: BrandData | undefined;
}

export enum State {
    New = 0,
    InvalidData = 1,
    CreationInProgress = 2,
    CreationError = 3,
    SuccessfullyCreated = 4,
    Unknown = 5,
}

export interface BrandData {
    city: string;
    companyName: string;
    country: string;
    displayName: string;
    ein: string;
    einIssuingCountry: string;
    email: string;
    entityType?: BrandEntityType | undefined;
    linkForTextMessagingOptInTermsOfService: string;
    privacyPolicyLink?: string | undefined;
    phone: string;
    postalCode: string;
    primaryContactFirstName: string;
    primaryContactLastName: string;
    state: string;
    stockExchange?: BrandStockExchange | undefined;
    stockSymbol: string;
    street: string;
    website: string;
    publicCompanyInfo?: PublicCompanyInfo | undefined;
}

export enum BrandEntityType {
    PrivateProfit = 0,
    PublicProfit = 1,
}

export enum BrandStockExchange {
    None = 0,
    Nasdaq = 1,
    Nyse = 2,
    Amex = 3,
    Amx = 4,
    Asx = 5,
    B3 = 6,
    Bme = 7,
    Bse = 8,
    Fra = 9,
    Icex = 10,
    Jpx = 11,
    Jse = 12,
    Krx = 13,
    Lon = 14,
    Nse = 15,
    Omx = 16,
    Sehk = 17,
    Sgx = 18,
    Sse = 19,
    Sto = 20,
    Swx = 21,
    Szse = 22,
    Tsx = 23,
    Twse = 24,
    Vse = 25,
    Other = 26,
}

export interface PublicCompanyInfo {
    businessContactEmail?: string | undefined;
    stockSymbol: string;
    stockExchange: BrandStockExchange2;
}

export enum BrandStockExchange2 {
    None = 0,
    Nasdaq = 1,
    Nyse = 2,
    Amex = 3,
    Amx = 4,
    Asx = 5,
    B3 = 6,
    Bme = 7,
    Bse = 8,
    Fra = 9,
    Icex = 10,
    Jpx = 11,
    Jse = 12,
    Krx = 13,
    Lon = 14,
    Nse = 15,
    Omx = 16,
    Sehk = 17,
    Sgx = 18,
    Sse = 19,
    Sto = 20,
    Swx = 21,
    Szse = 22,
    Tsx = 23,
    Twse = 24,
    Vse = 25,
    Other = 26,
}

export interface TcrCampaignResponse {
    campaignId: number;
    isMarketing: boolean;
    isDefault: boolean;
    state: TcrCampaignState;
    data?: TcrCampaignData | undefined;
    error?: string | undefined;
}

export enum TcrCampaignState {
    Unknown = 0,
    New = 1,
    CreationInProgress = 2,
    Error = 3,
    SuccessfullyCreated = 4,
    Expired = 5,
}

export interface TcrCampaignData {
    useCases: string[];
    description: string;
    flags: TcrCampaignFlags;
    messageSamples: string[];
    messageFlow: string;
    optOutMessage: string;
    optInMessage: string;
    helpMessage: string;
    requiresOptIn: boolean;
}

export enum TcrCampaignFlags {
    AutoRenewal = 1,
    EmbeddedLink = 2,
    EmbeddedPhone = 4,
    AffiliateMarketing = 8,
    NumberPool = 16,
    AgeGated = 32,
    DirectLending = 64,
    SubscriberOptIn = 128,
    SubscriberOptOut = 256,
    SubscriberHelp = 512,
}

export interface GetTcrDataRequest {
    brandId: string;
}

export interface TcrBrandModel {
    tcrBrandId: number;
    dbaName?: string | undefined;
    ein?: string | undefined;
    status: TcrBrandStatus;
}

export enum TcrBrandStatus {
    NotSynced = 0,
    ScorePending = 1,
    Active = 2,
    Removed = 3,
    VettingPending = 4,
}

export interface Void {
}

export interface UpdateTcrBrandRequest {
    brandId: string;
    primaryContactFirstName?: string | undefined;
    primaryContactLastName?: string | undefined;
    website?: string | undefined;
    linkForTextMessagingOptInTermsOfService?: string | undefined;
    privacyPolicyLink?: string | undefined;
    email?: string | undefined;
    displayName?: string | undefined;
}

export interface CreateTcrCampaignResponse {
    campaignId: number;
    brandId: number;
}

export interface CreateTcrCampaignRequest {
    brandId: string;
    smsObjective: string;
    messageSamples: string[];
    tcrBrandId?: number | undefined;
}

export interface ArchiveUrlShorteningDomainRequest {
    brandId: string;
    domainId: string;
}

export interface GetBrandPhoneNumberSettingsResponse {
    phoneNumbers: BrandPhoneNumber[];
    autoresponder?: Autoresponder | undefined;
}

export interface BrandPhoneNumber {
    phoneNumber: string;
    forwardingNumber?: string | undefined;
    isDefaultForwardingNumber?: boolean | undefined;
    dateAdded?: Date | undefined;
    addedBy?: string | undefined;
    isTollFree: boolean;
    enableSms: boolean;
    defaultCallType?: string | undefined;
    status?: string | undefined;
    campaign?: string | undefined;
    messaging?: string | undefined;
}

export interface Autoresponder {
    isEnabled: boolean;
    replyMessage: string;
}

export interface GetBrandPhoneNumberRequest {
    brandId: string;
}

export interface UpdateBrandPhoneNumberSettingsRequest {
    brandId: string;
    phoneNumbers: UpdateBrandPhoneNumber[];
    autoresponder?: Autoresponder | undefined;
}

export interface UpdateBrandPhoneNumber {
    phoneNumber: string;
    forwardingNumber?: string | undefined;
}

export interface SmsRegistration {
    businessDetails: BusinessDetails;
    messagingUsageDetails: MessagingUsageDetails;
}

export interface BusinessDetails {
    ein: string;
    einIssuingCountry: string;
    legalBusinessName: string;
    contactPhoneNumber: string;
    primaryContact: PrimaryContact;
    address: Address;
    contactEmail: string;
    companyWebsite: string;
    termsOfServiceLink: string;
    privacyPolicyLink?: string | undefined;
    dbaName: string;
    isPubliclyTraded: boolean;
    stockInfo?: StockInfo | undefined;
}

export interface PrimaryContact {
    firstName: string;
    lastName: string;
}

export interface Address {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
}

export interface StockInfo {
    symbol: string;
    exchange: StockExchange;
}

export enum StockExchange {
    None = 0,
    Nasdaq = 1,
    Nyse = 2,
    Amex = 3,
    Amx = 4,
    Asx = 5,
    B3 = 6,
    Bme = 7,
    Bse = 8,
    Fra = 9,
    Icex = 10,
    Jpx = 11,
    Jse = 12,
    Krx = 13,
    Lon = 14,
    Nse = 15,
    Omx = 16,
    Sehk = 17,
    Sgx = 18,
    Sse = 19,
    Sto = 20,
    Swx = 21,
    Szse = 22,
    Tsx = 23,
    Twse = 24,
    Vse = 25,
    Other = 26,
}

export interface MessagingUsageDetails {
    smsObjective: string;
    sampleMessage1: string;
    sampleMessage2: string;
}

export interface GetSmsRegistrationRequest {
    brandId: string;
}

export interface SendSmsRegistrationRequest {
    brandId: string;
    registration: SmsRegistration;
}

export interface ResultOfBusinessResult {
    value?: BusinessResult | undefined;
}

export interface BusinessResult {
    business: BusinessDetails;
    source: EinLookupResultSource;
}

export enum EinLookupResultSource {
    None = 0,
    TelecomInventory = 1,
    External = 2,
}

export interface FindByEinRequest {
    ein: string;
    einIssuingCountry: string;
}

export interface GetBrandStockExchangesResponse {
    stockExchanges: string[];
}

export interface CountriesWithStatesResponse {
    countries: CountryWithStates[];
}

export interface CountryWithStates {
    country: string;
    states: CountryState[];
}

export interface CountryState {
    abbreviation: string;
    name: string;
}

export interface UpdateTcrMarketingCampaignRequest {
    brandId: string;
    tcrCampaign?: number | undefined;
    tcrBrand?: number | undefined;
}

export interface AvailableDomainsResponse {
    domains: string[];
}

export interface GetEmailsResponse {
    emails: { [key: string]: EmailStatus; };
    count: number;
}

export interface EmailStatus {
    category: string;
    trustLevel: TrustLevel;
    validationDate?: Date | undefined;
}

export enum TrustLevel {
    Unspecified = 0,
    Invalid = 1,
    Low = 2,
    Medium = 3,
    High = 4,
    Unknown = -1,
}

export interface GetEmailsRequest {
    emailFilter?: string[] | undefined;
    dateTimeFrom?: Date | undefined;
    dateTimeTo?: Date | undefined;
    pagination?: PaginationRequest | undefined;
    sorting?: SortingRequest[] | undefined;
    categoryFilter?: CategoryFilter[] | undefined;
    trustLevelFilter?: TrustLevelFilter | undefined;
}

export interface PaginationRequest {
    pageNumber: number;
    pageSize: number;
}

export interface SortingRequest {
    field: SortingField;
    isDescending: boolean;
}

export enum SortingField {
    Unspecified = 0,
    Address = 1,
    Date = 2,
    Category = 3,
}

export enum CategoryFilter {
    Undeliverable = 0,
    Typo = 1,
    Risky = 2,
    AcceptAll = 3,
    Unknown = 4,
    Disposable = 5,
    Role = 6,
    InvalidSyntax = 7,
    SmtpValid = 8,
    VerifiedValid = 9,
    Pending = -1,
}

export enum TrustLevelFilter {
    Low = 1,
    Medium = 2,
    High = 3,
}

export type FileResponse = Blob;
